export const g = {
    ENV: `${process.env.ENV}`,
    DATA_API: `${process.env.REACT_APP_API}`,
    API: `${process.env.REACT_APP_API_ENDPOINT}`,
    VERSION: `${process.env.VERSION}`,
    SOCKET: `${process.env.SOCKET_ENDPOINT}`,
};
